module.exports = __webpack_public_path__ + "media/images/pc/stores/funabashi/access/chiba_funabashi_point1_6-ea2512ed5b6efc8d8cd620bb4c78eda6.jpg";